import { HTMLAttributes, ReactNode } from 'react';

import { Label } from './label';
import { Fieldset } from './fieldset';

type RadioGroupProps = HTMLAttributes<HTMLDivElement> & {
  label: ReactNode;
  helper?: {
    text: string;
    link: string;
  };
};

export function RadioGroup(props: RadioGroupProps) {
  const { label, className = '', helper, ...rest } = props;

  return (
    <Fieldset className={className}>
      <Label>
        <span className="mr-1">{label}</span>
        {helper ? (
          <a href={helper.link} target="_blank" rel="noopener noreferrer" className="text-accent">
            {helper.text}
          </a>
        ) : null}
      </Label>
      <div className="inline-flex items-center flex-wrap gap-4 mt-2" {...rest} />
    </Fieldset>
  );
}
